//export const Header = 'Header';


export function ToggleChange(toggle) {
    return (dispatch) => {
        dispatch({
            type: 'togglechange',
            payload:toggle
          })
    }
}





// WEBPACK FOOTER //
// ./src/redux/action/Header.js